(function () {
var $07732a3550d3d4db$var$checkBoxEl = document.querySelector("#checkbox");
var $07732a3550d3d4db$var$body = document.querySelector("body");
var $07732a3550d3d4db$var$Theme = {
    LIGHT: "light-theme",
    DARK: "dark-theme"
};
var $07732a3550d3d4db$var$STORAGE_KEY = "theme";
if ($07732a3550d3d4db$var$checkBoxEl) $07732a3550d3d4db$var$checkBoxEl.addEventListener("change", $07732a3550d3d4db$export$2e2bcd8739ae039);
$07732a3550d3d4db$var$savedThemeOnReloaded();
function $07732a3550d3d4db$export$2e2bcd8739ae039(evt) {
    var value = "";
    if (evt.currentTarget.checked) {
        value = $07732a3550d3d4db$var$Theme.DARK;
        $07732a3550d3d4db$var$body.classList.add(value);
        $07732a3550d3d4db$var$body.classList.remove($07732a3550d3d4db$var$Theme.LIGHT);
    } else {
        value = $07732a3550d3d4db$var$Theme.LIGHT;
        $07732a3550d3d4db$var$body.classList.remove($07732a3550d3d4db$var$Theme.DARK);
        $07732a3550d3d4db$var$body.classList.add(value);
    }
    localStorage.setItem($07732a3550d3d4db$var$STORAGE_KEY, value);
}
function $07732a3550d3d4db$var$savedThemeOnReloaded() {
    var savedValue = localStorage.getItem($07732a3550d3d4db$var$STORAGE_KEY);
    if (savedValue) $07732a3550d3d4db$var$body === null || $07732a3550d3d4db$var$body === void 0 ? void 0 : $07732a3550d3d4db$var$body.classList.add(savedValue);
    else $07732a3550d3d4db$var$body === null || $07732a3550d3d4db$var$body === void 0 ? void 0 : $07732a3550d3d4db$var$body.classList.add($07732a3550d3d4db$var$Theme.LIGHT);
    if ($07732a3550d3d4db$var$checkBoxEl) {
        if (savedValue === $07732a3550d3d4db$var$Theme.DARK) $07732a3550d3d4db$var$checkBoxEl.checked = true;
        else $07732a3550d3d4db$var$checkBoxEl.checked = false;
    }
}


var $581ff7f4d6f24945$var$wraperMobileMenuEl = document.querySelector(".js-wraper-mobile-menu");
var $581ff7f4d6f24945$var$menuMobileEl = document.querySelector(".js-modal-mobile-menu");
var $581ff7f4d6f24945$var$burgerBtnEl = document.querySelector(".js-burger");
var $581ff7f4d6f24945$var$closeModalBtnEl = document.querySelector(".js-close-menu");
var $581ff7f4d6f24945$var$headerEl = document.querySelector(".header-container");
var $581ff7f4d6f24945$var$body = document.body;
var $581ff7f4d6f24945$var$homeBtnEl = document.querySelector(".js-modal-home-btn");
var $581ff7f4d6f24945$var$listBtnEl = document.querySelector(".js-modal-list-btn");
var $581ff7f4d6f24945$var$iconListBtn = document.querySelector(".list-btn-svg-menu");
$581ff7f4d6f24945$var$burgerBtnEl === null || $581ff7f4d6f24945$var$burgerBtnEl === void 0 ? void 0 : $581ff7f4d6f24945$var$burgerBtnEl.addEventListener("click", $581ff7f4d6f24945$var$showModal);
$581ff7f4d6f24945$var$closeModalBtnEl === null || $581ff7f4d6f24945$var$closeModalBtnEl === void 0 ? void 0 : $581ff7f4d6f24945$var$closeModalBtnEl.addEventListener("click", $581ff7f4d6f24945$var$closeModal);
if (window.location.href === $581ff7f4d6f24945$var$listBtnEl.href) {
    $581ff7f4d6f24945$var$listBtnEl.classList.add("current");
    $581ff7f4d6f24945$var$homeBtnEl.classList.remove("current");
    $581ff7f4d6f24945$var$iconListBtn.classList.remove("fill");
    $581ff7f4d6f24945$var$homeBtnEl.classList.add("pudding");
} else if (window.location.href === $581ff7f4d6f24945$var$homeBtnEl.href) {
    $581ff7f4d6f24945$var$homeBtnEl.classList.remove("pudding");
    $581ff7f4d6f24945$var$listBtnEl.classList.add("padding");
    $581ff7f4d6f24945$var$iconListBtn.classList.add("fill");
}
function $581ff7f4d6f24945$var$showModal(elem) {
    $581ff7f4d6f24945$var$headerEl === null || $581ff7f4d6f24945$var$headerEl === void 0 ? void 0 : $581ff7f4d6f24945$var$headerEl.classList.add("index");
    $581ff7f4d6f24945$var$wraperMobileMenuEl === null || $581ff7f4d6f24945$var$wraperMobileMenuEl === void 0 ? void 0 : $581ff7f4d6f24945$var$wraperMobileMenuEl.classList.add("no-scroll");
    $581ff7f4d6f24945$var$body === null || $581ff7f4d6f24945$var$body === void 0 ? void 0 : $581ff7f4d6f24945$var$body.classList.add("no-scroll");
    $581ff7f4d6f24945$var$wraperMobileMenuEl === null || $581ff7f4d6f24945$var$wraperMobileMenuEl === void 0 ? void 0 : $581ff7f4d6f24945$var$wraperMobileMenuEl.classList.remove("is-hidden-mobile");
    $581ff7f4d6f24945$var$menuMobileEl.classList.add("active-mobile-menu");
    $581ff7f4d6f24945$var$burgerBtnEl === null || $581ff7f4d6f24945$var$burgerBtnEl === void 0 ? void 0 : $581ff7f4d6f24945$var$burgerBtnEl.classList.add("is-hidden-btn");
    $581ff7f4d6f24945$var$closeModalBtnEl === null || $581ff7f4d6f24945$var$closeModalBtnEl === void 0 ? void 0 : $581ff7f4d6f24945$var$closeModalBtnEl.classList.remove("is-hidden-btn");
}
function $581ff7f4d6f24945$var$closeModal() {
    $581ff7f4d6f24945$var$wraperMobileMenuEl === null || $581ff7f4d6f24945$var$wraperMobileMenuEl === void 0 ? void 0 : $581ff7f4d6f24945$var$wraperMobileMenuEl.classList.remove("no-scroll");
    //wraperMobileMenuEl?.classList.add('is-hidden-mobile')
    $581ff7f4d6f24945$var$burgerBtnEl === null || $581ff7f4d6f24945$var$burgerBtnEl === void 0 ? void 0 : $581ff7f4d6f24945$var$burgerBtnEl.classList.remove("is-hidden-btn");
    $581ff7f4d6f24945$var$closeModalBtnEl === null || $581ff7f4d6f24945$var$closeModalBtnEl === void 0 ? void 0 : $581ff7f4d6f24945$var$closeModalBtnEl.classList.add("is-hidden-btn");
    $581ff7f4d6f24945$var$body === null || $581ff7f4d6f24945$var$body === void 0 ? void 0 : $581ff7f4d6f24945$var$body.classList.remove("no-scroll");
    $581ff7f4d6f24945$var$menuMobileEl.classList.remove("active-mobile-menu");
}
var $581ff7f4d6f24945$var$home = document.querySelector(".modal-home-btn");
var $581ff7f4d6f24945$var$list = document.querySelector(".modal-list-btn");
$581ff7f4d6f24945$var$list.addEventListener("click", function() {
    if (window.location.href === "shoplist" && $581ff7f4d6f24945$var$list.textContent === "Shopping list") $581ff7f4d6f24945$var$list.classList.add("current");
});


console.log(document.scrollHeight);
var $83489510f74ba855$var$footerG = document.querySelector(".footer_container_group");
var $83489510f74ba855$var$team = document.querySelector(".team_wrap");
console.log(window.scrollY);
window.addEventListener("scroll", function() {
    if ($83489510f74ba855$var$team.offsetHeight - window.scrollY > 823) {
        console.log($83489510f74ba855$var$team.offsetHeight - window.scrollY);
        $83489510f74ba855$var$footerG.style.bottom = "-72px";
    } else {
        $83489510f74ba855$var$footerG.style.position = "fixed";
        $83489510f74ba855$var$footerG.style.bottom = "0px";
        $83489510f74ba855$var$footerG.style.left = "50%";
        $83489510f74ba855$var$footerG.style.transform = "translate(-50%)";
        $83489510f74ba855$var$footerG.style.width = "100%";
    }
}); // if (document.scrollHeight === document.offsetHeight) {
 //   footerG.style.position = 'fixed';
 //   footerG.style.bottom = '0px';
 //   footerG.style.left = '50%';
 //   footerG.style.transform = 'translate(-50%)';
 //   footerG.style.width = '100%';
 // }



})();
//# sourceMappingURL=group.1360bb51.js.map
